export enum PowerState {
    Standby = 10,
    Running = 11,
    Hibernating = 12,
    ChargingFinished = 20,
    ChargingNormal = 21
}